module.exports = __webpack_public_path__ + "static/media/Dr.NeeliPrasadTrustedMobiVehicleAvatarInc.USA.1b2ad9e5.jpg";